<script lang="ts" setup="">
import { type NavigationGuardReturn, useRoute } from 'vue-router'

const route = useRoute<'/upgrade-draft-study/[trialId]'>()

definePage({
  beforeEnter(to) {
    if (!('ctms_id' in to.query)) {
      return {
        name: 'NotFound',
        params: { pathMatch: to.path.split('/').slice(1) },
        query: to.query,
        hash: to.hash,
      } as NavigationGuardReturn
    }
    return true
  },
})
</script>

<template>
  <StudyFlow
    mode="draft-upgrade"
    :trial-id="route.params.trialId"
    :ctms-id="route.query['ctms_id'] as string"
  />
</template>
